<template>
	<div class="microscope">
		<div class="header">
			<h2 class="coco fs-1-5 white">Lens: {{ microscopeTitle }}</h2>
		</div>
		<div class="content">
			<div class="top-content">
				<div class="left">
					<button class="zoom-handler" :class="canZoomOut ? '' : 'cant-zoom'" @click="triggerZoomOut()">
						<img src="@/assets/icons/arrow-left-icon.png" alt="" />
					</button>
					<span class="fs-1-1 montserra-b white">Changer de vue</span>
					<button class="zoom-handler" :class="canZoomIn ? '' : 'cant-zoom'" @click="triggerZoomIn()">
						<img src="@/assets/icons/arrow-right-icon.png" alt="" />
					</button>
				</div>
				<div class="right fs-1-5 montserra-b white">x {{ currentZoom }}</div>
			</div>
			<div class="bottom-content">
				<img v-if="currentZoom === 5" src="@/assets/microscope/microscope_x5.svg" alt="" />
				<img v-else-if="currentZoom === 10" src="@/assets/microscope/microscope_x10.svg" alt="" />
				<img v-else-if="currentZoom === 100" src="@/assets/microscope/microscope_x100.svg" alt="" />
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	.microscope {
		background-color: var(--black-bgc);
		width: 100%;
		min-height: 30%;
		border: 1px solid var(--white);
		border-radius: var(--border) var(--border) 0 0;
		border-bottom: none;
		display: flex;
		flex-direction: column;
		.header,
		.content {
			box-sizing: border-box;
			width: 100%;
			padding: 1rem;
		}

		.header {
			box-sizing: border-box;
			border-bottom: 1px solid #fff;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}
		.content {
			padding-top: 0.75rem;
			padding-bottom: 1rem;
			display: flex;
			flex-direction: column;
			.top-content {
				display: flex;
				justify-content: space-between;
				align-items: center;
				.left {
					display: flex;
					align-items: center;
					span {
						margin: 0 1rem;
					}
					button.zoom-handler {
						padding: 0;
						img {
							height: 1.5rem;
						}
						&.cant-zoom {
							opacity: 0.2;
							cursor: not-allowed;
						}
					}
				}
				.right {
					text-align: left;
				}
			}
			.bottom-content {
				flex-grow: 1;
				padding-top: 1.5rem;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					max-height: 100%;
					max-width: 30%;
				}
			}
		}
	}
</style>
<script>
	import { mapState, mapActions } from "vuex";
	import { wording } from "../../js/constants.js";
	export default {
		data() {
			return {};
		},
		computed: {
			...mapState(["currentZoom", "selectedEntity"]),
			microscopeTitle() {
				switch (this.currentZoom) {
					case 5:
						return wording.microscope.x5;
					case 10:
						return wording.microscope.x10;
					case 100:
						return wording.microscope.x100;
					default:
						return "errror";
				}
			},
			canZoomIn() {
				if (this.selectedEntity !== null && this.currentZoom !== 100) return true;
				return false;
			},
			canZoomOut() {
				if (this.currentZoom !== 5) return true;
				return false;
			},
		},
		methods: {
			...mapActions(["zoomIn", "zoomOut"]),
			triggerZoomIn() {
				if (this.canZoomIn) this.zoomIn();
			},
			triggerZoomOut() {
				if (this.canZoomOut) this.zoomOut();
			},
		},
	};
</script>
